import { buildCategories } from "../../data/building";
import Container from "../ui/Container";
import SectionHeader from "../ui/SectionHeader";

function WhatWeBuild() {
  return (
    <section className="py-16 sm:py-20">
      <Container>
        <SectionHeader title="What We Build" subtitle="Compact products across focused, practical categories." />
        <div className="mt-9 grid gap-x-8 gap-y-7 sm:grid-cols-2 lg:grid-cols-5">
          {buildCategories.map((category) => (
            <article key={category.title} className="transition-all duration-200 ease-in-out">
              <div className="flex h-8 w-8 items-center justify-center rounded-xl border border-border text-xs font-semibold text-accent">
                {category.icon}
              </div>
              <h3 className="mt-4 text-sm font-semibold text-primary">{category.title}</h3>
              <p className="mt-2 text-sm leading-6 text-secondary">{category.description}</p>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default WhatWeBuild;
